import { reportingMoney } from '../contracts/reporting-policy.generated';
import { majorAmount } from '../contracts/marketplace-reporting-policy.generated';

export const REVENUE_BUCKETED_LABEL = 'Bucketed by currency';

/** Presentation only; admission and currency units stay with the shared policies. */
export function formatMinorRevenueDisplay(amountMinor: unknown, currencyCode: unknown): string {
  const money = reportingMoney(amountMinor, currencyCode);
  return formatRevenueDisplay(
    money.amountMinor == null || !money.currencyCode ? null : majorAmount(money.amountMinor, money.currencyCode),
    money.currencyCode,
    undefined,
    { emptyLabel: 'Amount unavailable' }
  );
}

type RevenueDisplayOptions = {
  compact?: boolean;
  emptyLabel?: string;
};

function formatCurrencyValue(value: number, currency: string, compact = false): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    notation: compact ? 'compact' : 'standard',
    ...(compact ? { minimumFractionDigits: 0, maximumFractionDigits: 1 } : {}),
  }).format(value);
}

export function formatRevenueDisplay(
  amount: number | null | undefined,
  currency: string | null | undefined,
  totalsByCurrency?: Record<string, number>,
  options: RevenueDisplayOptions = {}
): string {
  const { compact = false, emptyLabel = REVENUE_BUCKETED_LABEL } = options;

  if (amount == null || !currency) {
    const entries = Object.entries(totalsByCurrency || {});
    if (!entries.length) return emptyLabel;
    return entries.map(([code, value]) => formatCurrencyValue(value, code, compact)).join(' / ');
  }

  return formatCurrencyValue(amount, currency, compact);
}
